const GAME_OPEN = 'GAME_OPEN';
const RECONNECT_POPUP = 'RECONNECT_POPUP';
const SESSION_EXPIRED = 'SESSION_EXPIRED';
const INSUFFICIENT_AMOUNT = 'INSUFFICIENT_AMOUNT';
const OPEN_SLOT_HISTORY = 'openSlotHistory';

export const PopupTypes = {
  SESSION_EXPIRED,
  RECONNECT_POPUP,
  GAME_OPEN,
  INSUFFICIENT_AMOUNT,
  OPEN_SLOT_HISTORY,
};
